// extracted by mini-css-extract-plugin
module.exports = {"form":"file-upload-modal-page__form___3C8CP"};